<template>
    <div
    class="price"
    v-bind:class="color"
    >
        {{price}}
    </div>
</template>

<script>
export default {
  name: 'KZPrice',
  props: {
    color: String,
    price: Number,
  },
};
</script>

<style scoped>
.price {
    display: flex;
    width: 140px;
    align-items: center;
    justify-content: center;
    height: 68px;
    color: #00000093;
    font-size: 44px;;
    background:
    repeating-linear-gradient(
        transparent,transparent 2px, rgba(90, 90, 90, 0.1) 4px
        ),
    repeating-linear-gradient(
        90deg,
        transparent,transparent 2px, rgba(90, 90, 90, 0.1) 4px
        );
}

/* colors */
.gray {
    background-color: #b6b6b6;
}
.blue {
    background-color: #2dd7f2;
}
.green {
    background-color: #6bd000;
}
.orange {
    background-color: #e9c017;
}
.red {
    background-color: #dd3a28;
}
</style>
